import { useAppSelector } from "app/hooks"
import useNativeAppPaywallUrl from "features/notification/useNativeAppPaywallUrl"
import React from "react"
import { checkHasAIEntitlement, checkIsBasePlan } from "utils"
import { isInWebView } from "utils/webViewDetection"

const PaywallTriggerWrapper = ({
  children,
  isCheckingAIScan = false,
}: {
  children: React.ReactNode
  isCheckingAIScan?: boolean
}) => {
  const userPlan = useAppSelector((state) => state.payment.userPlan)
  const getUserPlanLoading = useAppSelector(
    (state) => state.payment.getUserPlanLoading,
  )

  const isBasePlan = checkIsBasePlan(userPlan?.type ?? "")
  const hasAIEntitlement = checkHasAIEntitlement(userPlan?.entitlements ?? [])
  const condition = isCheckingAIScan ? !hasAIEntitlement : isBasePlan

  const nativeAppPaywallUrl = useNativeAppPaywallUrl()

  if (isInWebView() && condition && !getUserPlanLoading) {
    return (
      <a
        href={nativeAppPaywallUrl}
        style={{ textDecoration: "none", color: "inherit" }}
      >
        {children}
      </a>
    )
  }

  return <>{children}</>
}

export default PaywallTriggerWrapper
